export function kmsStableStringify(value) {
  if (value === null)
    return "null";
  if (value === void 0)
    return "null";
  if (typeof value === "number") {
    if (!Number.isFinite(value))
      return "null";
    return JSON.stringify(value);
  }
  if (typeof value === "boolean")
    return JSON.stringify(value);
  if (typeof value === "string")
    return JSON.stringify(value);
  if (value instanceof Date && !Number.isNaN(value.getTime()))
    return JSON.stringify(value.toISOString());
  if (Array.isArray(value))
    return "[" + value.map(kmsStableStringify).join(",") + "]";
  if (typeof value === "object") {
    const keys = Object.keys(value).filter((k) => value[k] !== void 0).sort();
    return "{" + keys.map((k) => JSON.stringify(k) + ":" + kmsStableStringify(value[k])).join(",") + "}";
  }
  return JSON.stringify(String(value));
}
